module.exports = __webpack_public_path__ + "img/barcode.2b9a0b9.png";